"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scope = void 0;
class Scope {
    constructor() {
        this.values = new Map();
    }
    declare(name, token) {
        this.values.set(name, { token, defined: false, used: false });
    }
    define(name) {
        this.values.get(name).defined = true;
    }
    has(name) {
        const val = this.values.get(name);
        const declared = val !== undefined;
        return { declared: declared, defined: declared && val.defined };
    }
    use(name) {
        this.values.get(name).used = true;
    }
    set(name) {
        this.values.set(name, { defined: true, used: true });
    }
    entries() {
        return this.values.entries();
    }
}
exports.Scope = Scope;
